import avatarIcons1 from "@icons/avatar/ic-contact-male-1.svg";
import avatarIcons2 from "@icons/avatar/ic-contact-male-2.svg";
import avatarIcons3 from "@icons/avatar/ic-contact-male-3.svg";
import avatarIcons4 from "@icons/avatar/ic-contact-male-4.svg";
import avatarIcons5 from "@icons/avatar/ic-contact-male-5.svg";
import avatarIcons6 from "@icons/avatar/ic-contact-male-6.svg";
import avatarIcons7 from "@icons/avatar/ic-contact-male-7.svg";
import avatarIcons8 from "@icons/avatar/ic-contact-male-8.svg";
import avatarIcons9 from "@icons/avatar/ic-contact-male-9.svg";

export const avatarIcons = {
  1: avatarIcons1,
  2: avatarIcons2,
  3: avatarIcons3,
  4: avatarIcons4,
  5: avatarIcons5,
  6: avatarIcons6,
  7: avatarIcons7,
  8: avatarIcons8,
  9: avatarIcons9,
};

export const avatarIconsMr = {
  1: avatarIcons1,
  2: avatarIcons2,
  3: avatarIcons3,
  4: avatarIcons6,
  5: avatarIcons7,
  6: avatarIcons1,
  7: avatarIcons2,
  8: avatarIcons3,
  9: avatarIcons6,
};

export const avatarIconsMs = {
  1: avatarIcons4,
  2: avatarIcons5,
  3: avatarIcons8,
  4: avatarIcons9,
  5: avatarIcons4,
  6: avatarIcons5,
  7: avatarIcons8,
  8: avatarIcons9,
  9: avatarIcons4,
};